export const STEPS_MOBILE = ['downloadSteps.step1', 'downloadSteps.step2', 'downloadSteps.step3'];

export const STEPS_DESKTOP = ['downloadSteps.step0', ...STEPS_MOBILE];
